import Api from "../index";

export const addQuiz = async (payload) => {
	const response = await Api.post(`${process.env.REACT_APP_EXAM_DOMAIN}/quiz`, payload);
	return response;
};
